import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Scissors, Palette, Sparkles, Wind, Smile, Droplet } from 'lucide-react';
const services = [{
  icon: <Scissors strokeWidth={1} size={32} data-id="element-215" />,
  title: 'Стрижки',
  description: 'Чоловічі, жіночі, дитячі стрижки будь-якої складності.'
}, {
  icon: <Palette strokeWidth={1} size={32} data-id="element-216" />,
  title: 'Фарбування',
  description: 'Балаяж, шатуш, аіртач та класичне фарбування.'
}, {
  icon: <Sparkles strokeWidth={1} size={32} data-id="element-217" />,
  title: 'Хімічна та біозавивка',
  description: 'Створення ідеальних локонів з турботою про волосся.'
}, {
  icon: <Wind strokeWidth={1} size={32} data-id="element-218" />,
  title: 'Укладка волосся',
  description: 'Вечірні, весільні та повсякденні укладки.'
}, {
  icon: <Smile strokeWidth={1} size={32} data-id="element-219" />,
  title: 'Манікюр і педикюр',
  description: 'Комплексний догляд за вашими нігтями.'
}, {
  icon: <Droplet strokeWidth={1} size={32} data-id="element-220" />,
  title: 'Прокол вух',
  description: 'Безпечний та швидкий прокол для дорослих і дітей.'
}];
export function Services() {
  return <section id="services" className="py-32 bg-surface" data-id="element-221">
      <div className="container mx-auto px-6 md:px-12" data-id="element-222">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-223">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-224">
            Послуги
          </h2>
          <div className="w-12 h-1 bg-ink mx-auto rounded-full mb-8" data-id="element-225"></div>
          <p className="text-muted font-normal text-lg" data-id="element-226">
            Оберіть послугу, яка підходить саме вам.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-227">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="group flex flex-col p-10 bg-white rounded-[2rem] border border-line shadow-sm hover:shadow-xl transition-all duration-500" data-id="element-228">
              <div className="text-ink mb-8 p-4 bg-surface rounded-full w-fit border border-line group-hover:scale-110 transition-transform duration-500" data-id="element-229">
                {service.icon}
              </div>
              <h3 className="text-2xl font-heading font-semibold tracking-tight text-ink mb-4" data-id="element-230">
                {service.title}
              </h3>
              <p className="text-muted text-base font-normal leading-relaxed flex-grow" data-id="element-231">
                {service.description}
              </p>

              <a href="#contact" className="mt-10 block w-full py-4 border border-line rounded-full text-center text-sm font-medium tracking-wide text-ink hover:bg-ink hover:text-white hover:border-ink transition-all duration-300" data-id="element-232">
                Записатися
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}